import { CalendarClock, Link2, Network, UserCheck } from "lucide-react";
import type { SlideProps } from "@/engine/types";
import { GlassCard, GradientText, Reveal, RevealItem, RevealList, SlideShell } from "@/ui";

const CARDS = [
  {
    icon: UserCheck,
    title: "E-E-A-T",
    body: (
      <>
        Ship content that matches <span className="font-semibold text-white">real questions</span>{" "}
        and shows who is behind it —{" "}
        <span className="font-semibold text-white">
          experience, expertise, authority, trust
        </span>
        .
      </>
    ),
  },
  {
    icon: Link2,
    title: "Earn links & mentions",
    body: (
      <>
        With <span className="font-semibold text-white">useful pages, data, tools, and
        relationships</span> — not bulk low-quality outreach.
      </>
    ),
  },
  {
    icon: Network,
    title: "Internal links & freshness",
    body: (
      <>
        Give important pages <span className="font-semibold text-white">clear context</span> and{" "}
        <span className="font-semibold text-white">crawl paths</span>; refresh key pages when
        facts change.
      </>
    ),
  },
] as const;

export function DurableAuthoritySlide({ active }: SlideProps) {
  return (
    <SlideShell chapter={1} title="Building authority the durable way">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-10">
        <RevealList active={active} stagger={0.18} delay={0.25} className="grid grid-cols-3 gap-8">
          {CARDS.map(({ icon: Icon, title, body }) => (
            <RevealItem key={title} className="h-full">
              <GlassCard className="group flex h-full flex-col gap-5 p-8 transition-transform duration-300 hover:-translate-y-1">
                <div className="flex h-14 w-14 items-center justify-center rounded-xl border border-white/10 bg-white/5 transition-colors duration-300 group-hover:border-accent-cyan/40">
                  <Icon className="h-7 w-7 text-accent-cyan" strokeWidth={2} />
                </div>
                <h3 className="font-display text-3xl font-semibold text-white">{title}</h3>
                <p className="text-2xl leading-relaxed text-white/80">{body}</p>
              </GlassCard>
            </RevealItem>
          ))}
        </RevealList>

        {/* Wide punchline strip */}
        <Reveal active={active} delay={1.1} y={24}>
          <GlassCard glow className="flex items-center justify-center gap-6 px-10 py-8">
            <CalendarClock className="h-9 w-9 shrink-0 text-accent-cyan" strokeWidth={2} />
            <p className="font-display text-4xl font-semibold tracking-tight text-white">
              Competitive niches move slowly: measure over{" "}
              <GradientText>months, not days</GradientText>.
            </p>
          </GlassCard>
        </Reveal>
      </div>
    </SlideShell>
  );
}
